/**
 * PATH: packages/job-hub/src/jobs/qa/QaCameraConfirmSheet.tsx
 * FILE_ID: JOBHUB-QA-CAMERA-CONFIRM-001
 * PURPOSE: Phone camera preview with Retake and Use photo before upload.
 */
import { useEffect, useState } from 'react'
import { MobileSheet } from '@quotech/ui'

export function QaCameraConfirmSheet({
  file,
  onRetake,
  onUse,
  onClose,
}: {
  file: File | null
  onRetake: () => void
  onUse: (file: File) => void
  onClose: () => void
}) {
  const [url, setUrl] = useState<string | null>(null)
  useEffect(() => {
    if (!file) {
      setUrl(null)
      return
    }
    const next = URL.createObjectURL(file)
    setUrl(next)
    return () => URL.revokeObjectURL(next)
  }, [file])
  return (
    <MobileSheet open={file != null} onClose={onClose} title="Use this photo?" sheetTestId="qa-camera-confirm">
      {url ? <img src={url} alt="" className="max-h-[45vh] w-full object-contain" /> : null}
      <div className="mt-3 flex gap-2">
        <button type="button" className="min-h-[44px] flex-1 rounded-md border border-border text-sm" onClick={onRetake}>
          Retake
        </button>
        <button
          type="button"
          className="min-h-[44px] flex-1 rounded-md bg-primary text-sm font-medium text-primary-foreground"
          onClick={() => { if (file) onUse(file) }}
        >
          Use photo
        </button>
      </div>
    </MobileSheet>
  )
}
